import { createGlobalStyle } from 'styled-components'

export default createGlobalStyle`
    .app-footer {
      display: none;
    }
`
